import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import { User } from '../../model/user';
import { plainToClass } from 'class-transformer';
// import {SharedMethods} from "../../../util/sharedMethods";
// import {NetworkService} from "../../../util/NetworkService";
import { SharedMethods } from '../../../../util/sharedMethods-service';
import swal from 'sweetalert2';



@Injectable()
export class DashboardService {


  iSconnecting: boolean = false;

  // caisse: Compte;

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              // public sharedMethods: SharedMethods
              public sharedMethods: SharedMethods,
              ) { }

    getDashBoard() {

      // this.iSconnecting = true;

      // return new Promise<any>(resolve => {
      return this.http.get(this.apiEndpoints.URL_GET_DASHBOARD, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});
      // });

    }



}
